import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Expenses from '@/components/Expenses'
import ViewExpenses from '@/components/ViewExpenses'
import TimesheetEntry from '@/components/TimesheetEntry'
import JobOverview from '@/components/JobOverview'
import Settings from '@/components/Settings'
import SignIn from '@/components/Signin'
import HolidayRequest from '@/components/HolidayRequest'
import JobDetails from '@/components/JobDetails'
import SchengenRequest from '@/components/SchengenRequest'
import SchengenTrips from '@/components/SchengenTrips'
import AuthGuard from './AuthGuard'
import NotAuthGuard from './NotAuthGuard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/Settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/',
      name: 'Hello',
      component: Hello,
      beforeEnter: AuthGuard
    },
    {
      path: '/Expenses/:shiftID?',
      name: 'Expenses',
      component: Expenses,
      beforeEnter: AuthGuard,
      props: true
    },
    {
      path: '/ViewExpenses/:shiftID?',
      name: 'ViewExpenses',
      component: ViewExpenses,
      beforeEnter: AuthGuard,
      props: true
    },
    {
      path: '/TimesheetEntry/:intent',
      name: 'TimesheetEntry',
      component: TimesheetEntry,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/JobDetails/:taID/:shiftInProgress/:jobID?',
      name: 'JobDetails',
      component: JobDetails,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/HolidayRequest',
      name: 'HolidayRequest',
      component: HolidayRequest,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/SchengenTrips',
      name: 'SchengenTrips',
      component: SchengenTrips,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/SchengenRequest',
      name: 'SchengenRequest',
      component: SchengenRequest,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/JobOverview/:taID',
      name: 'JobOverview',
      component: JobOverview,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/signin/:company?/:emp?',
      name: 'SignIn',
      component: SignIn,
      props: true,
      beforeEnter: NotAuthGuard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js